/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import moment from 'moment-timezone';
import { withTranslation } from 'react-i18next';
import {
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography
} from "@material-ui/core";
// import Image from "react-graceful-image";
import { useThemeData } from '../../context/ThemeDataContext'


/* EQUESTRIAN Events*/

function EventCard(props) {
  const {primary_color_2, font_family} = useThemeData().themeData.site.theme;
  const PHOTO_URL = process.env.REACT_APP_PHOTO_NORMAL_URL
  const { uitlever_datum, folder_naam, school_contactpersoon, school_plaats, site_id, folderchildren } = props.data

  let dateString = uitlever_datum;
  let dateObj = new Date(dateString);
  let momentObj = moment(dateObj);
  let day = momentObj.format('DD')
  let month = momentObj.format('MMM')

  let id = folderchildren.length > 0 ? folderchildren[0].folderchildren.length > 0 ? folderchildren[0].folderchildren[0].photos.length > 0 ? folderchildren[0].folderchildren[0].photos[0].id : null : null : null
  let first_photo = folderchildren.length > 0 ? folderchildren[0].folderchildren.length > 0 ? folderchildren[0].folderchildren[0].photos.length > 0 ? folderchildren[0].folderchildren[0].photos[0].file_name : null : null : null
  let folder_id = folderchildren.length > 0 ? folderchildren[0].folderchildren.length > 0 ? folderchildren[0].folderchildren[0].photos.length > 0 ? folderchildren[0].folderchildren[0].photos[0].folder_id : null : null : null; 

  return (
    <Card className="events" style={{
      fontFamily: `${font_family}`,
      color: `${primary_color_2}`,
      width: 'inherit'
    }}>
      <CardContent style={{
        minHeight: '24vh',
        backgroundImage: `url(${PHOTO_URL}${site_id}/${folder_id}/0/0/0/0/${id}/${first_photo})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        marginTop: '15px'
      }}>
      </CardContent>
      <CardActions style={{padding: '0.1rem'}} >
        <Grid container style={{margin: '0rem', height: '6rem'}}>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{
            padding: '0.1rem 1rem'
            // alignSelf: 'center'
          }}>
            <Typography
                style={{
                  fontWeight: 'bold',
                  color: primary_color_2
                }}
                variant="subtitle1"
              >
                {day}
              </Typography>
              <Typography
                  style={{
                    fontWeight: 'bold',
                    color: primary_color_2
                  }}
                variant="subtitle1"
              >
                {month}
              </Typography>
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={8} xl={8} style={{padding: '0.1rem 1rem', textAlign: 'left', alignSelf: 'center'}}>
            <Grid container>
              <b>
                {folder_naam}
              </b>
            </Grid>
            <Grid container>
              <p
              style={{fontSize: 'smaller'}}>
                {school_contactpersoon}, {school_plaats}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  )

}

export default React.memo(withTranslation('home')(EventCard))
